import type { Project } from "./common";
import type { Contact } from "./contact";

export interface CpeRapport {
  reportId: string;
  name: string;
  comments: string;
  bsReportCreatedAt: string; // ISO date string
  bsReportUpdatedAt: string; // ISO date string
  startDate: string; // ISO date string
  endDate: string; // ISO date string
  pdfExists: boolean;
}

export interface CpeAutoRapport {
  scheduledReportId: string;
  firstOccurrence: string;
  rruleString: string;
  reportTitle: string;
  reportType: string;
  contacts: Contact[];
  project: Project;
}

export interface CpeAutoRapportHistory {
  sentAt: string;
  s3Path: string;
  rruleString: string;
  endDate: string;
  startDate: string;
  sends: any;
  report: { id: string; name: string };
}

export const FrequencyType = [
  { key: "monthly", label: "bexRapport.auto.monthly" },
  { key: "bimonthly", label: "bexRapport.auto.bimonthly" },
  { key: "quarterly", label: "bexRapport.auto.quarterly" },
];
